import { render } from "./Rejoin.vue?vue&type=template&id=048f3d36&scoped=true"
import script from "./Rejoin.vue?vue&type=script&lang=js"
export * from "./Rejoin.vue?vue&type=script&lang=js"

import "./Rejoin.vue?vue&type=style&index=0&id=048f3d36&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-048f3d36"]])

export default __exports__